import script from "./CommonHomeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonHomeHeader.vue?vue&type=script&setup=true&lang=js"

import "./CommonHomeHeader.vue?vue&type=style&index=0&id=4b8df5f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8df5f2"]])

export default __exports__